import Vue from 'vue';
import dayjs from 'dayjs';
import {
  errCodeMap,
} from '@/lib/errors';
// eslint-disable-next-line import/no-cycle
import axios from '@/lib/axios';
// eslint-disable-next-line import/no-cycle
import fetch from '../../../lib/fetch';
import * as types from './types';
import { downLoadFileByUrl } from '../../../utils';
import { Task, TaskList } from '../../../utils/tasks/task';
import api from '@/apis/settlement';

const filterInit = {
  mediaType: '',
  mediaId: '',
  stime: dayjs()
    .subtract(6, 'd')
    .format('YYYYMMDD'),
  etime: dayjs().format('YYYYMMDD'),
};

const pageInfoInit = {
  page: 1,
  count: 10,
  total: 0,
};

export default {
  namespaced: true,
  state: {
    downloading: {
      v: 0,
    },
    type: -1, // 1 快结快付 2 聚鑫
    mediaSaasListMap: {},
    table: [],
    billlist: [],
    filter: {
      ...filterInit,
    },
    pageInfo: {
      ...pageInfoInit,
    },
    list_settlement_bill: [

    ],
    estimate_commission: {
      this_month: '0',
      last_month: '0',
    },
    /**
     * downloadmonth 个人用户下载结算单需要的月份
     * downloadbillData 下载账单暂存的数据结构
     * downloadbillnultiMonth 机构批量下载结算单需要的月份字段
     */
    // 批量下载结算单对应的月份
    downloadbillnultiMonth: '',
    // 下载账单单对应的月份
    downloadmonth: '',
    // 下载结算相关数据结构
    downloadbillData: {},
    loading: false,
    activeName: 'thrid',
  },
  mutations: {
    setDownLoading(state, {
      id,
      value,
    }) {
      state.downloading = {
        ...state.downloading,
        [id]: value,
      };
    },
    [types.SET_SETTLE_MEDIA](state, {
      type,
      map,
    }) {
      state.type = type;
      state.mediaSaasListMap = map;
    },
    [types.SET_STATISTIC_ORDER_FILTER](state, filter) {
      state.filter = {
        ...state.filter,
        ...filter,
      };
    },
    [types.RESET_STATISTIC_ORDER_FILTER](state) {
      state.filter = {
        ...filterInit,
      };
    },
    [types.SET_TABLE_LIST](state, {
      list,
      billlist,
    }) {
      if (list) state.table = list;
      if (billlist) state.billlist = billlist;
      setTimeout(() => {
        state.loading = false;
      }, 1000);
    },
    [types.SET_TABLE_PAGE_INFO](state, {
      pageInfo,
    }) {
      state.pageInfo = {
        ...state.pageInfo,
        ...pageInfo,
      };
    },
    [types.RESET_TABLE_PAGE_INFO](state) {
      state.pageInfo = {
        ...pageInfoInit,
      };
    },
    [types.SET_ESTIMATE_COMMISSION](state, {
      estimateCommission,
    }) {
      state.estimate_commission = {
        ...estimateCommission,
      };
    },
    // 下载的那当月账单
    [types.GET_DOWNLOAD](state, { month }) {
      state.downloadmonth = month;
    },
    // 批量下载结算单
    [types.GET_DOWNLOAD_BILL_MULI](state, { month }) {
      state.downloadbillnultiMonth = month;
    },
    // 下载结算单
    [types.GET_DOWNLOAD_BILL](state, opt) {
      state.downloadbillData = {
        sett_no: opt.sett_no,
        middle_end_id: opt.middle_end_id,
      };
    },
    [types.SET_ACCOUNT_TYPE](state, data) {
      state.activeName = data;
    },
  },
  actions: {
    getListOrder({
      dispatch, state,
    }, data) {
      state.loading = true;
      if (data.activeName === 'xepp') {
        dispatch('pageSettlementSummaryBills', data.middle_end_id);
      } else {
        dispatch('fetchEttlementBillList');
      }
    },
    // 获取小鹅KOC查询月账单列表
    async pageSettlementSummaryBills({
      commit,
    }, id) {
      // 查询月账单
      const res = await fetch.post('v3/cps_settlement/page_settlement_summary_bills', {
        middle_end_id: id,
        page_no: 1,
        page_size: 500,
      });
      commit(types.SET_TABLE_LIST, {
        billlist: res.dataList,
      });
    },
    // 获取单月份结算清单
    async fetchEttlementBillList({
      commit,
    }) {
      const res = await api.listSettlementBill();
      // 设置billlist，设置单月明细列表
      commit(types.SET_TABLE_LIST, {
        billlist: res.details,
      });
    },
    // 下载结算单
    async downLoadBilllist({
      state,
    }) {
      const res = await fetch.post('v1/settlement_account/settbill', {
        ...state.downloadbillData,
      }).catch((e) => {
        Vue.prototype.$tip.error(`下载失败${e}`);
      });
      if (!res.head || res.head.code !== 0) {
        Vue.prototype.$tip.error(res.head.msg || '获取结算账单下载地址失败');
        return;
      }

      const downloadUrl = res.file_url;
      const fileName = `${state.downloadbillData.settment_no}_order.pdf`;
      downLoadFileByUrl(downloadUrl, fileName);
    },

    async downloadBillListMulti({
      state,
    }) {
      Vue.prototype.$notification({
        type: 'success',
        icon: 'success',
        message: '下载数据中...',
        closeable: false,
      });

      api.batchDownloadSettlementDoc({ month: String(state.downloadbillnultiMonth)  }).then((res) => {
        if (res.head.code !== '0') {
          this.$tip.error(errCodeMap[res.head.code] || '导出数据失败');
          return;
        };
        if (res.zip_url) {
          Vue.prototype.$notification({
            type: 'success',
            icon: 'success',
            message: '下载成功',
            closeable: false,
          });
          downLoadFileByUrl(res.zip_url);
        }
      })
        .catch(() => {
          Vue.prototype.$tip.error('下载失败');
        });
    },
    // 下载账单
    async downLoadMonthList({
      state,
      commit,
      dispatch,
    }, { callback, biz }) {
      const month = state.downloadmonth;
      const name = `monthlist${month}`;
      commit('setDownLoading', {
        id: `monthlist${month}`,
        value: true,
      });
      const downloadtask = new Task(name);
      downloadtask.job = async () => {
        Vue.prototype.$notification({
          type: 'success',
          icon: 'success',
          message: `正在下载数据：${month}，数据将在准备好后自动下载，请勿关闭浏览器`,
          closeable: false,
        });
        try {
          const res = await api.downloadBill({ month: String(state.downloadmonth) });

          if (res.head.code !== '0') {
            this.$tip.error(res.head.msg || '导出数据失败');
            return;
          }
        } catch (error) {
          Vue.prototype.$tip.error('下载失败');
        }

        // 导出数据之后开始检查是否获取下载状态，通过轮训方式进行监听
        let timer = setInterval(async () => {
          const tellRes = await dispatch(
            'common/queryExportStatus',
            {
              biz,
            },
            {
              root: true,
            },
          );

          if (tellRes.head.code === '0') {
            clearInterval(timer);
            timer = null;
            const { file_name: url } = tellRes;
            // downloadFile(url);
            downLoadFileByUrl(url, name, '_self');
            Vue.prototype.$notification({
              type: 'success',
              icon: 'success',
              message: `${month}数据下载成功`,
              closeable: false,
            });

            commit('setDownLoading', {
              id: name,
              value: false,
            });

            // 还原可导出状态
            if (callback) callback.call(null);
            downloadtask.end();
          }
        }, 500);
      };

      TaskList.getInstance().addTask(downloadtask);
    },
    async fetchOrderList({
      state,
      commit,
    }) {
      const {
        mediaType,
        mediaId,
        stime,
        etime,
      } = state.filter;

      const data = {
        method: 'post',
        body: {
          media_type: mediaType === '全部' ? '' : mediaType,
          media_id: mediaId === '全部' ? '' : mediaId,
          start_time: stime,
          end_time: etime,
          page: state.pageInfo.page,
          count: state.pageInfo.count,
        },
      };

      const res = await axios.post('v1/settlement_account/wallet/estimated_earnings', data).catch(() => {
        Vue.prototype.$tip.error('获取预估佣金列表失败');
      });

      if (res.code !== 0) {
        Vue.prototype.$tip.error(errCodeMap[res.code] || '获取预估佣金列表失败');
      }

      commit(types.SET_TABLE_LIST, {
        list: res.data.single_commission,
      });

      if (res.data.pageinfo) {
        commit(types.SET_TABLE_PAGE_INFO, {
          pageInfo: {
            total: res.data.pageinfo.total,
          },
        });
      }
    },
    async getEstimateCommission({
      commit,
    }) {
      const estimateCommission = {
        this_month: 0,
        last_month: 0,
      };
      const res = await axios.post('v1/settlement_account/wallet/estimated_earnings', {
        method: 'post',
        body: {
          start_time: `${dayjs()
            .subtract(1, 'M')
            .format('YYYYMM')}01`,
          end_time: dayjs()
            .subtract(1, 'M')
            .format('YYYYMM') + dayjs()
            .subtract(1, 'M')
            .endOf('month')
            .format('DD'),
        },
      }).catch(() => {
        Vue.prototype.$tip.error('获取预估佣金列表失败');
      });

      if (res.code !== 0) {
        Vue.prototype.$tip.error(errCodeMap[res.code] || '获取预估佣金列表失败');
      }

      const res2 = await axios.post('v1/settlement_account/wallet/estimated_earnings', {
        method: 'post',
        body: {
          start_time: `${dayjs().format('YYYYMM')}01`,
          end_time: dayjs()
            .format('YYYYMM') + dayjs()
            .endOf('month')
            .format('DD'),
        },
      }).catch(() => {
        Vue.prototype.$tip.error('获取预估佣金列表失败');
      });

      if (res2.code !== 0) {
        Vue.prototype.$tip.error(errCodeMap[res2.code] || '获取预估佣金列表失败');
      }

      if (res.data.total_commission) {
        estimateCommission.this_month = res.data.total_commission / 100;
      }

      if (res2.data.total_commission) {
        estimateCommission.last_month = res2.data.total_commission / 100;
      }

      commit(types.SET_ESTIMATE_COMMISSION, {
        estimateCommission,
      });
    },
  },
  getters: {},
};
